import { render, staticRenderFns } from "./NotAvailableComponent.vue?vue&type=template&id=5de3f1b2&"
import script from "./NotAvailableComponent.vue?vue&type=script&lang=js&"
export * from "./NotAvailableComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotAvailableComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports